// @flow
import styled from 'styled-components';
import {
  textSemiBold,
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
} from './css';
import { Text7 } from './Text';

export const Text7Normal = styled(Text7)`
  ${textNormal};
`;

export const Text7Black = styled(Text7)`
  ${textBlack};
`;

export const Text7Bold = styled(Text7)`
  ${textBold};
`;

export const Text7SemiBold = styled(Text7)`
  ${textSemiBold};
`;

export const Text7BoldLoose = styled(Text7)`
  ${textBoldLoose};
`;
